import { ApplicationRef, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../modules/auth/services/auth.service';
import { CTranslateService } from '../pipes/c-translate/c-translate.service';
const moduleConfig = require('./../../modules.config.json');

@Injectable()
export class AppService {

  constructor(private authService: AuthService, private router: Router,
              private translateService: CTranslateService, private app: ApplicationRef) {
  }

  public static getApiUrl(mock = false) {
    return mock ? environment.mockApiUrl : environment.apiUrl;
  }

  public static getEnvs(name) {
    return name && environment[name] ? environment[name] : environment;
  }

  public static getAppSetting() {
    return AppService.getSettings(moduleConfig.app);
  }

  public static getModuleSetting(moduleName) {
    const module = moduleConfig.modules.filter(function (val) {
      return val.id === moduleName;
    });

    return module[0] ? AppService.getSettings(module[0]) : {};
  }

  public static getSettings(module) {
    let settingObj = {};

    if (module) {
      if (module.settings) {
        for (const i in module.settings['properties']) {
          const defaultValue = module.settings['properties'][i]['default'];
          settingObj[i] = typeof defaultValue !== 'undefined' ? defaultValue : null;
        }

        if (module['settingData']) {
          settingObj = Object.assign(settingObj, module['settingData']);
        }
      }
    }

    return settingObj;
  }

  public getMenuConfig() {
    if (moduleConfig.menus && moduleConfig.menus.length) {
      return moduleConfig.menus;
    }

    const menus = [];

    if (moduleConfig.modules && Array.isArray(moduleConfig.modules)) {
      moduleConfig.modules.forEach((item) => {
        if (item.enable && item.menu) {
          menus.push(item.menu);
        }
      });
    }
    return menus;
  }

  getAuthService(): AuthService {
    return this.authService;
  }

  getTranslateService(): CTranslateService {
    return this.translateService;
  }

  translate(input) {
    return this.translateService.translate(input);
  }

  navigate(input) {
    this.router.navigate(input);
  }

  getWidgetComponent(widgetName: string) {
    const factories = Array.from(this.app['_componentFactoryResolver']['_factories'].keys());
    return factories.find((x: any) => x.widgetName === widgetName);
  }
}
